// HomePage.js
import React from 'react';

const HomePage = () => {
  return (
    <div>
      <h1>Welcome to our Website!</h1>
      <p>Check out our awesome products and learn more about us.</p>
    </div>
  );
}

export default HomePage;
